import { IState } from '../../store';

export function selectMortgageRates(state: IState) {
  return state.mortgage.rates;
}
